import { render, staticRenderFns } from "./PosCustomerList.template.vue?vue&type=template&id=e8dd2190&scoped=true&"
var script = {}
import style0 from "./PosCustomerList.template.vue?vue&type=style&index=0&id=e8dd2190&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dd2190",
  null
  
)

export default component.exports